<template>
    <EmployeeApproveServiceReport></EmployeeApproveServiceReport>
</template>
<script>
    import EmployeeApproveServiceReport from '@/components/EmployeeApproveServiceReport.vue'
    export default {
        name: 'employee-service-report',
        components: {
            EmployeeApproveServiceReport
        }
    }
</script>